import React from 'react';

/**
 * @param loading
 * @param color Tailwind fill utility for the sparkles, e.g. 'fill-rezi-blue'.
 *   Defaults to the button label colour it was built for. Pass 'fill-current'
 *   to take the colour from the surrounding text instead.
 */
export const AiIcon = ({
  loading = false,
  color = 'fill-neutral-0',
}: {
  loading?: boolean;
  color?: string;
}) => {
  return (
    <div className={`relative mr-1 h-[14px] w-[14px]`}>
      <div
        className={`opacity-100 ${loading ? 'animate-[sparklesPrimary_0.9s_ease-in-out_infinite]' : ''}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={14}
          height={14}
        >
          <path
            d="M384 254.64a16.06 16.06 0 0 0-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 240.31a16 16 0 0 0 0 28.67l112.57 56.39 56.28 112.77a16 16 0 0 0 28.62 0l56.28-112.77L375.16 269a16.07 16.07 0 0 0 8.84-14.36z"
            className={color}
          />
        </svg>
      </div>
      <div
        className={`absolute top-0 right-0 opacity-40 ${loading ? 'animate-[sparklesSecondary_0.9s_ease-in-out_infinite]' : ''}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={6}
          height={6}
        >
          <path
            d="M384 254.64a16.06 16.06 0 0 0-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 240.31a16 16 0 0 0 0 28.67l112.57 56.39 56.28 112.77a16 16 0 0 0 28.62 0l56.28-112.77L375.16 269a16.07 16.07 0 0 0 8.84-14.36z"
            className={color}
          />
        </svg>
      </div>
      <div
        className={`absolute right-0 bottom-0 opacity-40 ${loading ? 'animate-[sparklesThird_0.9s_ease-in-out_infinite]' : ''}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={6}
          height={6}
        >
          <path
            d="M384 254.64a16.06 16.06 0 0 0-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 240.31a16 16 0 0 0 0 28.67l112.57 56.39 56.28 112.77a16 16 0 0 0 28.62 0l56.28-112.77L375.16 269a16.07 16.07 0 0 0 8.84-14.36z"
            className={color}
          />
        </svg>
      </div>
    </div>
  );
};
